import React from 'react'
import MainLayout from './Layout/mainlayout'
import { Switch, Route } from 'react-router'
import LandingPage from "./LandingPage/landingpage"
import { ADD_USER_ROUTE, CREATE_RATING_ROUTE, LEADERBOARD_ROUTE, USER_PROFILE_ROUTE } from '../constants/routes'
import CreateRating from './CreateRating/createrating'
import AddUserPage from './AddUser/adduserpage'
import UserProfilePage from './UserProfile/userprofilepage'
import LeaderboardPage from './Leaderboard/leaderboardpage'

export default function MainRouter() {
    return <MainLayout>
        <Switch>
            <Route path={CREATE_RATING_ROUTE} component={CreateRating}/>
            <Route path={ADD_USER_ROUTE} component={AddUserPage}/>
            <Route path={LEADERBOARD_ROUTE} component={LeaderboardPage}/>
            <Route path={USER_PROFILE_ROUTE} component={UserProfilePage}/>
            <Route path='' component={LandingPage}/>
        </Switch>
    </MainLayout>
}